"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearStagedExemptUsers = exports.updateStagedExemptUsers = exports.ExemptUsersStagedActionTypes = exports.updateSamlService = exports.updateSamlEntity = exports.updateSamlCertificate = exports.clearStagedSaml = exports.SingleSignonStagedActionTypes = exports.saveExemptUsers = exports.SaveExemptUsers = exports.SaveExemptUsersActionTypes = exports.unrequireSamlSettings = exports.requireSamlSettings = exports.UpdateSamlRequirement = exports.UpdateSamlRequirementActionTypes = exports.confirmSamlSettings = exports.ConfirmSamlSettings = exports.ConfirmSamlSettingsActionTypes = exports.saveSamlSettings = exports.SaveSamlSettings = exports.SaveSamlSettingsActionTypes = exports.deleteSamlSettings = exports.DeleteSamlSettings = exports.DeleteSamlSettingsActionTypes = exports.getSsoEnabled = exports.GetSsoEnabled = exports.GetSsoEnabledActionTypes = exports.loadSamlSettings = exports.FetchSamlSettings = exports.FetchSamlSettingsActionTypes = exports.SingleSignonApiActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fluxActions = require("flux-actions");

var _I18n = _interopRequireDefault(require("I18n"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _actions = require("settings-ui-lib/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _constants = require("./constants");

var SingleSignonApiActionTypes = (0, _namespacedKeyMirror.default)({
  CONFIRM_SAML_SETTINGS: null,
  DELETE_SAML_SETTINGS: null,
  FETCH_SAML_SETTINGS: null,
  SAVE_SAML_SETTINGS: null,
  UPDATE_SAML_REQUIREMENT: null,
  SAVE_EXEMPT_USERS: null,
  GET_SSO_ENABLED: null
}, 'singleSignOn');
exports.SingleSignonApiActionTypes = SingleSignonApiActionTypes;
var FetchSamlSettingsActionTypes = (0, _actions.createRequestTypes)(SingleSignonApiActionTypes.FETCH_SAML_SETTINGS);
exports.FetchSamlSettingsActionTypes = FetchSamlSettingsActionTypes;
var FetchSamlSettings = (0, _actions.createRequestActions)(FetchSamlSettingsActionTypes, {
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(FetchSamlSettingsActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('accountdefaults.security.singleSignOn.notifications.fetchError')));
  }
});
exports.FetchSamlSettings = FetchSamlSettings;
var loadSamlSettings = (0, _fluxActions.createAction)(SingleSignonApiActionTypes.FETCH_SAML_SETTINGS);
exports.loadSamlSettings = loadSamlSettings;
var GetSsoEnabledActionTypes = (0, _actions.createRequestTypes)(SingleSignonApiActionTypes.GET_SSO_ENABLED);
exports.GetSsoEnabledActionTypes = GetSsoEnabledActionTypes;
var GetSsoEnabled = (0, _actions.createRequestActions)(GetSsoEnabledActionTypes, {
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(GetSsoEnabledActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('accountdefaults.security.singleSignOn.notifications.fetchError')));
  }
});
exports.GetSsoEnabled = GetSsoEnabled;
var getSsoEnabled = (0, _fluxActions.createAction)(SingleSignonApiActionTypes.GET_SSO_ENABLED);
exports.getSsoEnabled = getSsoEnabled;
var DeleteSamlSettingsActionTypes = (0, _actions.createRequestTypes)(SingleSignonApiActionTypes.DELETE_SAML_SETTINGS);
exports.DeleteSamlSettingsActionTypes = DeleteSamlSettingsActionTypes;
var DeleteSamlSettings = (0, _actions.createRequestActions)(DeleteSamlSettingsActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(DeleteSamlSettingsActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('accountdefaults.security.singleSignOn.notifications.deleteSuccess')));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(DeleteSamlSettingsActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('accountdefaults.security.singleSignOn.notifications.deleteError')));
  }
});
exports.DeleteSamlSettings = DeleteSamlSettings;
var deleteSamlSettings = (0, _fluxActions.createAction)(SingleSignonApiActionTypes.DELETE_SAML_SETTINGS);
exports.deleteSamlSettings = deleteSamlSettings;
var SaveSamlSettingsActionTypes = (0, _actions.createRequestTypes)(SingleSignonApiActionTypes.SAVE_SAML_SETTINGS);
exports.SaveSamlSettingsActionTypes = SaveSamlSettingsActionTypes;
var SaveSamlSettings = (0, _actions.createRequestActions)(SaveSamlSettingsActionTypes, {
  failureMetaCreator: function failureMetaCreator(error) {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SaveSamlSettingsActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text("accountdefaults.security.singleSignOn.notifications.saveErrors." + (error.responseJSON.errors ? error.responseJSON.errors[0] : 'UNKNOWN'))));
  }
});
exports.SaveSamlSettings = SaveSamlSettings;
var saveSamlSettings = (0, _fluxActions.createAction)(SingleSignonApiActionTypes.SAVE_SAML_SETTINGS);
exports.saveSamlSettings = saveSamlSettings;
var ConfirmSamlSettingsActionTypes = (0, _actions.createRequestTypes)(SingleSignonApiActionTypes.CONFIRM_SAML_SETTINGS);
exports.ConfirmSamlSettingsActionTypes = ConfirmSamlSettingsActionTypes;
var ConfirmSamlSettings = (0, _actions.createRequestActions)(ConfirmSamlSettingsActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(ConfirmSamlSettingsActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('accountdefaults.security.singleSignOn.notifications.saveSuccess')));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(ConfirmSamlSettingsActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('accountdefaults.security.singleSignOn.notifications.saveError')));
  }
});
exports.ConfirmSamlSettings = ConfirmSamlSettings;
var confirmSamlSettings = (0, _fluxActions.createAction)(SingleSignonApiActionTypes.CONFIRM_SAML_SETTINGS);
exports.confirmSamlSettings = confirmSamlSettings;
var UpdateSamlRequirementActionTypes = (0, _actions.createRequestTypes)(SingleSignonApiActionTypes.UPDATE_SAML_REQUIREMENT);
exports.UpdateSamlRequirementActionTypes = UpdateSamlRequirementActionTypes;
var UpdateSamlRequirement = (0, _actions.createRequestActions)(UpdateSamlRequirementActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(UpdateSamlRequirementActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('accountdefaults.security.singleSignOn.notifications.saveSuccess')));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(UpdateSamlRequirementActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('accountdefaults.security.singleSignOn.notifications.saveError')));
  }
});
exports.UpdateSamlRequirement = UpdateSamlRequirement;
var requireSamlSettings = (0, _fluxActions.createAction)(SingleSignonApiActionTypes.UPDATE_SAML_REQUIREMENT, function () {
  return _constants.REQUIRED;
});
exports.requireSamlSettings = requireSamlSettings;
var unrequireSamlSettings = (0, _fluxActions.createAction)(SingleSignonApiActionTypes.UPDATE_SAML_REQUIREMENT, function () {
  return _constants.NOT_REQUIRED;
});
exports.unrequireSamlSettings = unrequireSamlSettings;
var SaveExemptUsersActionTypes = (0, _actions.createRequestTypes)(SingleSignonApiActionTypes.SAVE_EXEMPT_USERS);
exports.SaveExemptUsersActionTypes = SaveExemptUsersActionTypes;
var SaveExemptUsers = (0, _actions.createRequestActions)(SaveExemptUsersActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SaveExemptUsersActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('accountdefaults.security.singleSignOn.notifications.exemptions.saveSuccess')));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SaveExemptUsersActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('accountdefaults.security.singleSignOn.notifications.exemptions.saveError')));
  }
});
exports.SaveExemptUsers = SaveExemptUsers;
var saveExemptUsers = (0, _fluxActions.createAction)(SingleSignonApiActionTypes.SAVE_EXEMPT_USERS);
exports.saveExemptUsers = saveExemptUsers;
var SingleSignonStagedActionTypes = (0, _namespacedKeyMirror.default)({
  CLEAR_STAGED_SAML: null,
  UPDATE_SAML_CERTIFICATE: null,
  UPDATE_SAML_ENTITY: null,
  UPDATE_SAML_SERVICE: null
}, 'singleSignOn');
exports.SingleSignonStagedActionTypes = SingleSignonStagedActionTypes;
var clearStagedSaml = (0, _fluxActions.createAction)(SingleSignonStagedActionTypes.CLEAR_STAGED_SAML);
exports.clearStagedSaml = clearStagedSaml;
var updateSamlCertificate = (0, _fluxActions.createAction)(SingleSignonStagedActionTypes.UPDATE_SAML_CERTIFICATE, function (payload) {
  return payload;
});
exports.updateSamlCertificate = updateSamlCertificate;
var updateSamlEntity = (0, _fluxActions.createAction)(SingleSignonStagedActionTypes.UPDATE_SAML_ENTITY, function (payload) {
  return payload;
});
exports.updateSamlEntity = updateSamlEntity;
var updateSamlService = (0, _fluxActions.createAction)(SingleSignonStagedActionTypes.UPDATE_SAML_SERVICE, function (payload) {
  return payload;
});
exports.updateSamlService = updateSamlService;
var ExemptUsersStagedActionTypes = (0, _namespacedKeyMirror.default)({
  UPDATE_STAGED_EXEMPT_USERS: null,
  CLEAR_STAGED_EXEMPT_USERS: null
}, 'singleSignOn');
exports.ExemptUsersStagedActionTypes = ExemptUsersStagedActionTypes;
var updateStagedExemptUsers = (0, _fluxActions.createAction)(ExemptUsersStagedActionTypes.UPDATE_STAGED_EXEMPT_USERS, function (payload) {
  return payload;
});
exports.updateStagedExemptUsers = updateStagedExemptUsers;
var clearStagedExemptUsers = (0, _fluxActions.createAction)(ExemptUsersStagedActionTypes.CLEAR_STAGED_EXEMPT_USERS);
exports.clearStagedExemptUsers = clearStagedExemptUsers;